export default {
  type: 'raw_html',
  title: 'HTML',
  icon: 'file',
  template: `<div class="mb-3">
               <textarea 
                 id="{{::$id}}" 
                 code-editor 
                 data-mode="htmlmixed" 
                 ng-value="feature.content" 
                 ng-model="feature.content" 
                 value="{{feature.content}}">
               </textarea>
             </div>`,
  onPaste: function (elem) {
    return {
      type: 'raw_html',
      content: elem.html(),
    }
  },
  customHandleButtons: [
    {
      className: 'fa fa-caret-square-o-up btnShowAll',
      event: 'show-all',
      tooltip: 'Show/hide all markup',
    },
  ],
}
